import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeftSideMenuComponent } from './left-side-menu/left-side-menu.component';

const routes: Routes = [
  {
    path: '', component: LeftSideMenuComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../presentation/presentation.module').then(m => m.PresentationModule)
      }
    ]
  }
];
@NgModule({
  imports: [

    CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MasterLayoutRoutingModule { }
